// import "./App.css";
import axios from "axios";
import uploadImageIcon from "assets/icons/upImageIcon.svg";
import uploadVideoIcon from "assets/icons/uploadVideoIcon.svg";
import editIcon from "assets/icons/pen.svg";
import uploadButton from "assets/icons/uploadButton.svg";
import playIcon from "assets/icons/play-button.svg";
import pauseIcon from "assets/icons/pause-circle.svg";
import { useEffect, useRef, useState } from "react";
import { baseUrl } from "services";
import { addTokenToMedia } from "helpers/addTokenToMedia";
import { CheckCircleFilled } from "@ant-design/icons";
import { Progress } from "antd";
const ENDPOINTS = {
  UPLOAD: `${baseUrl}api/video/resumableUploadByChunks`,
  UPLOAD_STATUS: `${baseUrl}api/video/statusResumableUploadByChunks`,
  UPLOAD_REQUEST: `${baseUrl}api/video/requestResumableUploadByChunks`,
};
export default function VideoUploader({
  setFilePath,
  selectedEpisodeIndex,
  disableMe,
  srcVideo,
}) {
  const [file, setfile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState("");
  const uploadRequestRef = useRef(null);
  const [fileId, setfileId] = useState("");
  const [uploading, setuploading] = useState(false);
  const [showPauseButton, setshowPauseButton] = useState(false);
  const [showResumeButton, setshowResumeButton] = useState(false);
  const [uploadedVideoPreview, setUploadedVideoPreview] = useState(
    addTokenToMedia(baseUrl + srcVideo)
  );
  useEffect(() => {
    setUploadedVideoPreview(addTokenToMedia(baseUrl + srcVideo));
  }, [srcVideo]);
  const [done, setDone] = useState(false);
  const progressBarClass = done ? "progress-finished" : "progress-bar";

  useEffect(() => {
    const handleOffline = () => {
      setshowResumeButton(true);
      setshowPauseButton(false);
      abortFileUpload();
    };

    window.addEventListener("offline", handleOffline);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const uploadFileChunks = (file, startingByte = 0, fileId) => {
    setuploading(true);
    setshowPauseButton(true);
    const formData = new FormData();
    const req = new XMLHttpRequest();
    const chunk = file.slice(startingByte);

    formData.append("chunk", chunk, file?.name);
    formData.append("fileId", fileId);

    req.open("POST", ENDPOINTS.UPLOAD, true);
    req.setRequestHeader(
      "Content-Range",
      `bytes=${startingByte}-${startingByte + chunk.size}/${file?.size}`
    );
    req.setRequestHeader("X-File-Id", fileId);

    req.onload = (e) => {
      if (req.status === 200) {
        const response = JSON.parse(req.responseText);
        setUploadedVideoPreview((prev) =>
          addTokenToMedia(baseUrl + response.data.filePath)
        );
        setshowPauseButton(false);
        setshowResumeButton(false);
        setDone(true);

        setFilePath(
          response.data?.filePath,
          response.data?.lowQualityfilePath,
          response.data?.fileName,
          response.data?.duration
        );
      } else {
        setUploadStatus("failed");
      }
    };

    req.upload.onprogress = (e) => {
      const loaded = startingByte + e.loaded;
      setProgress((loaded * 100) / file?.size);
    };

    req.onabort = (e) => setshowPauseButton(false);

    uploadRequestRef.current = req;
    req.send(formData);
  };

  const uploadFile = (file) => {
    return fetch(ENDPOINTS.UPLOAD_REQUEST, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: file?.name,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        setfileId(res.fileId);

        uploadFileChunks(file, 0, res.fileId);
      })
      .catch((e) => {});
  };

  const resumeFileUpload = (file) => {
    if (file) {
      return fetch(
        `${ENDPOINTS.UPLOAD_STATUS}?fileName=${file?.name}&fileId=${fileId}`
      )
        .then((res) => res.json())
        .then((res) => {
          uploadFileChunks(file, res.totalChunkUploaded, fileId);
        })
        .catch((e) => {});
    }
  };

  const abortFileUpload = async () => {
    if (uploadRequestRef.current) {
      uploadRequestRef.current.abort();
      setUploadStatus("paused");
      return true;
    }

    return false;
  };

  // const retryFileUpload = (file) => {
  //   if (file) {
  //     return fetch(
  //       `${ENDPOINTS.UPLOAD_STATUS}?fileName=${file.name}&fileId=${file.options.fileId}`,
  //     )
  //       .then((res) => res.json())
  //       .then((res) => {
  //         uploadFileChunks(file, {
  //           ...file.options,
  //           startingByte: Number(res.totalChunkUploaded),
  //         });
  //       })
  //       .catch(() => {
  //         uploadFileChunks(file, file.options);
  //       });
  //   }
  // };

  const handlePauseResumeClick = () => {
    if (uploadStatus === "paused") {
      resumeFileUpload(file);

      setUploadStatus("uploading");
    } else {
      abortFileUpload();
    }
  };

  const inputHandler = (e) => {
    setshowPauseButton(false);
    setshowResumeButton(false);
    if (file) {
      e.preventDefault();
      abortFileUpload();
      setfile(e.target.files[0]);
      uploadFile(e.target.files[0]);
    } else {
      e.preventDefault();
      setfile(e.target.files[0]);
      uploadFile(e.target.files[0]);
    }
    e.currentTarget.value = "";
  };

  return (
    <>
      <div
        style={{
          // marginTop: "8px",
          overflow: "hidden",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          // justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f0f0f0",
          borderRadius: "12px",
        }}
      >
        {" "}
        {!(uploading || srcVideo) && (
          <label
            className="upload-btn"
            style={{
              margin: "auto auto",
              cursor: "pointer",
              width: "211px",
              height: "48px",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              overflow: "hidden",
              borderRadius: "12px",
              backgroundColor: " #ffffff",
              boxShadow: "0px 12px 13px rgba(0, 0, 0, 0.0392156863)",
            }}
          >
            <div role="button" className="upload-files__button  ">
              <div className="upload-files__icon">
                <img src={uploadButton} alt="" />
              </div>
              <div className="upload-files__title">{"Upload Video"}</div>
              <div className="upload-files__icon">
                <img src={uploadVideoIcon} alt="" />
              </div>
            </div>
            <input
              disabled={disableMe}
              type="file"
              accept="video/*"
              id="file-upload-input"
              style={{ display: "none" }}
              onChange={inputHandler}
            />
          </label>
        )}
        {uploading && !done ? (
          <div className="upload-edit-icon mrg-x-20">
            <label>
              <img role="button" src={editIcon} alt="edit" />
              <input
                disabled={disableMe}
                type="file"
                accept="video/*"
                id="file-upload-input"
                style={{ display: "none" }}
                onChange={inputHandler}
              />
            </label>
          </div>
        ) : null}
        {(done || srcVideo) && (
          <div style={{ position: "relative", height: "245px" }}>
            <video
              controls
              key={uploadedVideoPreview}
              style={{ width: "872px", height: "104%" }}
            >
              <source src={uploadedVideoPreview} type="video/mp4" />
              {/* Add additional source elements for different video formats if necessary */}
              Your browser does not support the video tag.
            </video>

            <div className="upload-edit-icon mrg-x-20">
              <label>
                <img role="button" src={editIcon} alt="edit" />
                <input
                  disabled={disableMe}
                  type="file"
                  accept="video/*"
                  id="file-upload-input"
                  style={{ display: "none" }}
                  onChange={inputHandler}
                />
              </label>
            </div>
          </div>
        )}
        {Boolean(progress) && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "1rem",
              position: "absolute",
              bottom: "-40px",
              // transform: "translateY(40px)",
              // margin: "0 auto",
              padding: "0 .5rem",
              width: "100%",
              flexGrow: "1",
            }}
          >
            <Progress percent={`${Math.round(progress)}`}></Progress>

            {/* <CheckCircleFilled
              style={{
                fontSize: "16px",
                color: "#52c41a",
                display: `${done ? "block" : "none"}`,
              }}
            /> */}
            <button
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                border: "none",
                display: `${showPauseButton ? "block" : "none"}`,
              }}
              onClick={(e) => {
                e.preventDefault();
                abortFileUpload();
                setshowPauseButton(false);
                setshowResumeButton(true);
              }}
            >
              <img src={pauseIcon} alt="play icon" style={{ width: "24px" }} />
            </button>

            <button
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                border: "none",
                display: `${showResumeButton ? "block" : "none"}`,
              }}
              onClick={(e) => {
                e.preventDefault();
                resumeFileUpload(file);
                setshowResumeButton(false);
                setshowPauseButton(true);
              }}
            >
              <img src={playIcon} alt="play icon" style={{ width: "24px" }} />
            </button>
          </div>
        )}
      </div>
    </>
  );
}
